// extracted by mini-css-extract-plugin
export default {"wrapper":"B8e5F","content":"eUlEY","dropzone":"W2YXk"};